// extracted by mini-css-extract-plugin
export default {"wrapper":"video_wrapper__ZKVi7","closeBtn":"video_closeBtn__B-FOC","error":"video_error__xOYZg","playIcon":"video_playIcon__qhXcF"};